import { render, staticRenderFns } from "./POSSales.vue?vue&type=template&id=7356e003&scoped=true"
import script from "./POSSales.vue?vue&type=script&lang=js"
export * from "./POSSales.vue?vue&type=script&lang=js"
import style0 from "./POSSales.vue?vue&type=style&index=0&id=7356e003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7356e003",
  null
  
)

export default component.exports